module.exports = __webpack_public_path__ + "img/PayrollInfo.967741f8.svg";